import { css } from 'styled-components';

import { getFontStyle } from '~components/Text/helper';

export function getMenuCss(gnbId: string) {
  switch (gnbId) {
    case 'salaryreport':
      return css`
        &::before {
          background-image: url('/images/ico-gnb-salaryreport.svg');
        }
      `;
    case 'jobdom':
      return css`
        &::before {
          background-image: url('/images/ico-gnb-jobdom.svg');
        }
      `;
    case 'dashboard':
      return css`
        &::before {
          background-image: url('/images/ico-gnb-dashboard.svg');
        }
      `;
    case 'companylist':
      return css`
        &::before {
          background-image: url('/images/ico-gnb-company-list.svg');
        }
      `;
    default:
      return null;
  }
}
